import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const UserMenu = ({ onAuthModalOpen, isScrolled = false }) => {
  const { user, isAuthenticated, logout } = useAuth();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    if (isDropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isDropdownOpen]);

  const handleLogout = () => {
    logout();
    setIsDropdownOpen(false);
  };

  if (!isAuthenticated) {
    return (
      <div className="flex items-center space-x-3">
        <button
          onClick={() => onAuthModalOpen('login')}
          className="px-4 py-2 text-sm font-medium text-df-muted border border-df-border rounded-lg hover:text-df-accent hover:border-df-accent transition-all duration-200"
        >
          Iniciar Sesión
        </button>
        <button
          onClick={() => onAuthModalOpen('register')}
          className="px-4 py-2 text-sm font-medium bg-df-accent-strong hover:bg-df-accent-deep text-white rounded-lg transition-all duration-200"
        >
          Registrarse
        </button>
      </div>
    );
  }

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
        className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-df-text bg-df-surface border border-df-border rounded-lg hover:border-df-accent transition-all duration-200"
      >
        <span className="truncate max-w-[100px] md:max-w-[120px]">
          {user?.name || user?.email.split('@')[0]}
        </span>
        <svg
          className={`w-4 h-4 transition-transform flex-shrink-0 text-df-muted ${isDropdownOpen ? 'rotate-180' : ''}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {isDropdownOpen && (
        <div className="absolute right-0 mt-2 w-56 bg-df-surface border border-df-border rounded-lg shadow-xl shadow-black/30 z-50 overflow-hidden">
          <div className="py-1">
            <Link
              to="/perfil"
              onClick={() => setIsDropdownOpen(false)}
              className="block px-4 py-3 text-sm text-df-muted hover:text-df-text hover:bg-df-surface2 transition-colors"
            >
              Mi Perfil
            </Link>
            <Link
              to="/pedidos"
              onClick={() => setIsDropdownOpen(false)}
              className="block px-4 py-3 text-sm text-df-muted hover:text-df-text hover:bg-df-surface2 transition-colors border-t border-df-border"
            >
              Mis Pedidos
            </Link>
            {user?.role_id && user.role_id <= 2 && (
              <Link
                to="/admin"
                onClick={() => setIsDropdownOpen(false)}
                className="block px-4 py-3 text-sm text-df-cyan hover:bg-df-surface2 transition-colors border-t border-df-border font-medium"
              >
                Panel Administrativo
              </Link>
            )}
            <button
              onClick={handleLogout}
              className="block w-full px-4 py-3 text-sm text-left text-df-danger hover:bg-df-surface2 transition-colors border-t border-df-border"
            >
              Cerrar Sesión
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserMenu;
